import { render, staticRenderFns } from "./environmentSettings.vue?vue&type=template&id=72fc186b&scoped=true&"
import script from "./environmentSettings.vue?vue&type=script&lang=js&"
export * from "./environmentSettings.vue?vue&type=script&lang=js&"
import style0 from "./environmentSettings.vue?vue&type=style&index=0&id=72fc186b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc186b",
  null
  
)

component.options.__file = "environmentSettings.vue"
export default component.exports